export default __webpack_public_path__ + "static/media/leafletjs.508b5b0f.svg";